/* Don't connect this file to dynamic bundle.
 * Branding mustn't be in dynamic files.
 * */

export const ECWID_CUSTOM_PAGE_TYPE = 'siteplus';
export const ECWID_DASH_PAGE_TYPE = 'ecomdash';
export const ECWID_NATIVE_PAGE_TYPE = 'dashboard';
